export const environment = {
  production: true,
  authServerUrl: "https://login.warehousing.omniopti.eu/auth",
  dashboardUrl: "https://dashboard-stage.warehousing.omniopti.eu",
  owlUrl: "https://owl-stage.warehousing.omniopti.eu",
  languages: [
    {
      name: "SLO 🇸🇮",
      link: "https://sl.yamas-stage.warehousing.omniopti.eu",
    },
    {
      name: "ENG 🇬🇧",
      link: "https://yamas-stage.warehousing.omniopti.eu",
    },
  ],
  apiUrl: "https://api.yamas-stage.warehousing.omniopti.eu",
};